/**
 * Podium Webchat Lazy Loader - Showtime V2
 *
 * Injects the Podium widget script only once, triggered by:
 *   1. First user interaction (pointerdown)
 *   2. Browser idle (requestIdleCallback with 30s delay)
 *
 * The custom trigger button is hidden by default — Podium's own
 * "Text us" bubble appears once the script loads, so users only
 * ever see a single chat button.
 */
(function () {
  'use strict';

  var src = window.__PODIUM_SRC__;
  var token = window.__PODIUM_TOKEN__;
  if (!src) return;

  var loaded = false;

  /**
   * Inject the Podium script tag once.
   */
  function loadPodium() {
    if (loaded) return;
    loaded = true;

    var script = document.createElement('script');
    script.src = src;
    script.id = 'podium-widget';
    script.defer = true;
    script.async = true;
    if (token) {
      script.setAttribute('data-organization-api-token', token);
    }
    document.body.appendChild(script);

    removeListeners();
  }

  function onInteraction() {
    loadPodium();
  }

  function addListeners() {
    window.addEventListener('pointerdown', onInteraction, { once: true });
  }

  function removeListeners() {
    window.removeEventListener('pointerdown', onInteraction);
  }

  // 1. First user interaction
  addListeners();

  // 2. Browser idle callback with 30-second delay
  // Delayed well past Lighthouse trace window (~20s TTI) to avoid
  // CLS penalty from Podium widget iframe injection during audit.
  setTimeout(function () {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(function () {
        loadPodium();
      }, { timeout: 5000 });
    } else {
      loadPodium();
    }
  }, 30000);
})();
